/* RESPONSIBLE TEAM: team-knowledge-foundations */

export enum SettingTypes {
  GDPR = 'gdpr',
  Simple = 'simple',
  CCPA = 'ccpa',
}
